export const basePrimes = [18446744073709551557n, 18446744073709551533n, 18446744073709551521n, 18446744073709551437n, 18446744073709551427n, 18446744073709551359n, 18446744073709551337n, 18446744073709551293n, 18446744073709551263n, 18446744073709551253n];
export const randomUInt64 = () => {let r = BigInt(0); for(let i=0; i<64; i++) if(Math.random()>0.5) r+=2n**BigInt(i); return r} 
export const chooseRandom = /**@template T@param {[T]} l @return {T}*/l => l[Math.floor(Math.random() * l.length)]

export function modularExponentiation(base, exponent, modulo){
    const exponentBinary = exponent.toString(2).split("").reverse();
    const computedSquares = [base % modulo];
    let result = exponentBinary[0] == "1" ? computedSquares[0] : 1n;

    for(const e of exponentBinary.slice(1)){
        computedSquares.push(computedSquares.at(computedSquares.length - 1) ** 2n % modulo);
        if(e == "1"){
            result *= computedSquares.at(computedSquares.length - 1);
            result %= modulo;
        }
    }

    return result;
}

/** @param {string} key */
function createKeySignature(key){
    const encodedKey = btoa(key);
    let signature = 1;
    for(let i = 0; i < encodedKey.length; i++){
        signature += encodedKey.charCodeAt(i);
        signature *= encodedKey.charCodeAt(i);
        signature %= 0x100000000;
    }
    return btoa((signature.toString(16)).padStart(8, "0").toUpperCase());
}

/** @param {string} message, @param {string} key */
export function encrypt(message, key){
    const cyphertext_intermediate = createKeySignature(key) + btoa(String.fromCharCode(...(new TextEncoder()).encode(message)));
    const cypherArray = [];
    for(let i = 0; i < cyphertext_intermediate.length; i++)
        cypherArray.push(cyphertext_intermediate.charCodeAt(i) ^ key.charCodeAt(i % key.length));
    return btoa(String.fromCodePoint(...cypherArray));
}

/** @param {string} cyphertext, @param {string} key */
export function decrypt(cyphertext, key){
    try{
        const signature = createKeySignature(key);
        const message_intermediate = atob(cyphertext);
        const validationCheckArray = [];
        for(let i = 0; i < signature.length; i++)
            validationCheckArray.push(message_intermediate.charCodeAt(i) ^ key.charCodeAt(i % key.length));
        const validationCheck = String.fromCodePoint(...validationCheckArray);

        if (validationCheck != signature) return undefined;

        const messageArray = [];
        for(let i = signature.length; i < message_intermediate.length; i++)
            messageArray.push(message_intermediate.charCodeAt(i) ^ key.charCodeAt(i % key.length));
        return atob(String.fromCodePoint(...messageArray));
    }catch{
        return undefined;
    }
}
